import { where } from 'firebase/firestore'

import { getConvertedData } from '../../../models/interface.helper'

import FirestoreService from '../../firestoreService'

import { UserDocumentModel } from '../../../models/user-documents/user-documents.model'

import { IUserDocument } from '../../../models/user-documents/user-documents.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getByRider = async (registrationId: string, riderId: string) => {
  const userDocuments: IUserDocument[] = []

  const usersDocumentsSnaps = await FirestoreService.filterItems(COLLECTIONS.USERS_DOCUMENTS.NAME, [
    where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId),
    where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.RIDER_ID.KEY, '==', riderId),
  ])

  usersDocumentsSnaps.forEach((currDoc) => {
    const current = getConvertedData(UserDocumentModel.fromFirestoreDoc(currDoc).toObject())
    userDocuments.push(current)
  })

  return userDocuments
}

const listenByRider = (
  registrationId: string,
  riderId: string,
  setUsersDocuments: (value: IUserDocument[]) => void
) => {
  FirestoreService.listenItems({
    collection_name: COLLECTIONS.USERS_DOCUMENTS.NAME,
    queries: [
      where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId),
      where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.RIDER_ID.KEY, '==', riderId),
    ],
    callback: (snaps) => {
      const userDocuments: IUserDocument[] = []
      snaps.forEach((currDoc) => {
        const current = getConvertedData(UserDocumentModel.fromFirestoreDoc(currDoc).toObject())
        userDocuments.push(current)
      })
      setUsersDocuments(userDocuments)
    },
  })
}

const getByEvent = async (eventId: string) => {
  const userDocuments: IUserDocument[] = []

  const usersDocumentsSnaps = await FirestoreService.filterItems(COLLECTIONS.USERS_DOCUMENTS.NAME, [
    where(COLLECTIONS.USERS_DOCUMENTS.FIELDS.EVENT_ID.KEY, '==', eventId),
  ])

  usersDocumentsSnaps.forEach((currDoc) => {
    const current = getConvertedData(UserDocumentModel.fromFirestoreDoc(currDoc).toObject())
    userDocuments.push(current)
  })

  return userDocuments
}

const UsersDocumentsService = {
  getByRider,
  listenByRider,
  getByEvent,
}

export default UsersDocumentsService
